import { render, staticRenderFns } from "./MarginTopCustoms.vue?vue&type=template&id=c9b816a6"
import script from "./MarginTopCustoms.vue?vue&type=script&lang=js"
export * from "./MarginTopCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports